import React from 'react';

import { ADMIN_DOCUMENTS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';

const ManagePacketsPage = React.lazy(() => import('../../../pages/Admin/ManageDocuments/ManagePacketsPage'));

export default {
  label: 'navigation.admin.documents.title',
  group: ADMIN,
  to: '/administration/packets',
  route: '/administration/packets',
  component: ManagePacketsPage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_DOCUMENTS,
  area: ADMIN_DOCUMENTS,
  hasNavBar: true,
};
